import React, { FC, useState } from "react";
import { getCryptedString, setClass } from "../../utils";
import { isMobile } from 'react-device-detect';
import { Input } from "../input";
import { Trash, Warning } from "../svgs";
import { Timer } from "../timer";
import '../../styles/components/emailField.scss';

interface EmailFieldProps {
  email: string;
  isVerified?: boolean;
  onDelete?: (value: string) => void;
  resend?: (email: string) => void;
}

export const EmailField: FC<EmailFieldProps> = ({ email, isVerified, onDelete, resend }) => {
  const key = `${getCryptedString(email)}Timer`;
  
  const deleteEmail = () => {
    sessionStorage.removeItem(key);
    onDelete(email);
  }
  const [timerVisibility, setTimerVisibility] = useState(sessionStorage.getItem(key) !== null);

  const resendConfirmation = () => {
    resend(email);
    setTimerVisibility(true);
    sessionStorage.setItem(key, `${Date.now()}`);
  }

  const timesUp = () => {
    setTimerVisibility(false);
    sessionStorage.removeItem(key);
  }

  return (
    <>
      <div className={setClass('email-field', onDelete && 'mutable', isMobile && 'mobile')}>
        <Input
          variant={'square'}
          error={!isVerified}
          value={email}
          disabled
        />
        { onDelete && 
          <div 
            className='clickable' 
            onClick={deleteEmail}
          >
            <Trash />
          </div>
        }
      </div>
      {!isVerified && (
        <div className="email-label-container">
          <Warning />
          <label 
            className="unverified-email"
          >
            {"Почта не подтверждена. "}
            {timerVisibility 
              ? (
                <span>
                  <span>{'Повторная отправка через '}</span>
                  <Timer 
                    onTimesUp={timesUp}
                    startTimestamp={+sessionStorage.getItem(key)} 
                    timerDurationInMs={60000} 
                  />
                </span>
              )
              : (
                <a 
                  href={`#no_scroll${email}`}
                  onClick={resendConfirmation}
                >
                  Прислать письмо еще раз.
                </a>
              )
            }
          </label>
        </div>
      )}
    </>
  )
}
